import {
  DevelopmentTool,
  DeploymentHostType,
} from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { NonTypeTab, type TemplateTab } from '../types/TemplateTabs';

export type LoginParams = {
  postLogin: string;
  postSignup?: string;
  referralInfo?: string;
};

export const DOCS: Partial<Record<TemplateTab, string>> = {
  [DevelopmentTool.BLOCKS]:
    'https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-blocks/get-started/blocks-unboxed-a-quick-tour',
  [DevelopmentTool.CLI]:
    'https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/get-started/quick-start#step-1--create-a-new-app-project',
  [DevelopmentTool.DEV_CENTER]:
    'https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/about-self-hosting-for-wix-apps',
  [NonTypeTab.ALL]:
    'https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/choose-the-right-wix-framework-for-your-app-development-needs#choose-the-right-wix-framework-for-your-app-development-needs',
};

export const ROUTES = {
  NodeJS: 'https://nodejs.org/en/',
  NpmDocs: 'https://www.npmjs.com/get-npm',
  YarnDocs: 'https://yarnpkg.com/en/docs/install',
  GitDocs: 'https://git-scm.com/downloads',
  WixDeveloperAccount: `https://users.wix.com/signin?loginDialogContext=signup&studio=true`,
  CliLearnMore:
    'https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/get-started/quick-start#step-1--create-a-new-app-project',
  appChecksAndTestingDocs:
    'https://dev.wix.com/docs/build-apps/build-your-app/testing/app-checks-and-testing-guide',
  devCenterExtensionsPage: (appId: string) =>
    `https://dev.wix.com/apps/${appId}/extensions`,
  loginPage: ({ postLogin, postSignup, referralInfo }: LoginParams) => {
    const url = new URL('https://users.wix.com/signin');
    url.searchParams.set('loginDialogContext', 'login');
    referralInfo && url.searchParams.set('referralInfo', referralInfo);
    url.searchParams.set('postLogin', postLogin);
    url.searchParams.set('postSignUp', postSignup ?? postLogin);
    url.searchParams.set('studio', 'true');
    return url.href;
  },
};

export const DEPLOY_APP_LINK_DOC: Partial<Record<DeploymentHostType, string>> =
  {
    [DeploymentHostType.VERCEL]:
      'https://vercel.com/docs/deployments/generated-urls',
    [DeploymentHostType.NETLIFY]:
      'https://docs.netlify.com/domains-https/custom-domains/',
  };

export const ENV_VARIABLE_DOC: Partial<Record<DeploymentHostType, string>> = {
  [DeploymentHostType.VERCEL]:
    'https://vercel.com/docs/projects/environment-variables/system-environment-variables',
  [DeploymentHostType.NETLIFY]:
    'https://docs.netlify.com/environment-variables/overview/',
};

export const DEPLOY_APP_VENDOR_SITE: Partial<
  Record<DeploymentHostType, string>
> = {
  [DeploymentHostType.VERCEL]: 'https://vercel.com/',
  [DeploymentHostType.NETLIFY]: 'https://www.netlify.com/',
};

export const APP_PAGES = {
  OPEN_BLOCKS_TEMPLATE_ROUTE: '/open-blocks-template',
  TEMPLATES_MAIN_PAGE: '/',
  TEMPLATE_PAGE: '/template',
};

export const APP_BASE_ROUTE = `/apps-templates`;

export const REFERRAL_INFO = {
  SELF_HOSTED_MODAL: 'SELF-HOSTED-MODAL',
  SELF_HOSTED_FLOW: 'SELF-HOSTED-FLOW',
  BLOCKS_TEMPLATE_FLOW: 'BLOCKS-TEMPLATE-FLOW',
  BLOCKS_TEMPLATE_WITH_NAMESPACE_FLOW: 'BLOCKS-TEMPLATE-WITH-NAMESPACE-FLOW',
};
